export const translationOrganizations_sv_part2 = {
  orgDetailKnowledgeBaseIndexesMustBeArray: "Kunskapsbasindex måste vara en JSON-array.",
  orgDetailSettingsSaved: "Organisationsinställningar sparade.",
  orgDetailUnableToSaveSettings: "Det gick inte att spara organisationsinställningar.",
  orgDetailChatbotAttached: "Kopplade {chatbotId} till den här organisationen.",
  orgDetailChatbotDetached: "Kopplade bort {chatbotId} från den här organisationen.",
  orgDetailPaymentEventAdded: "Betalningshändelse tillagd.",
  orgDetailPaymentEventSaved: "Betalningshändelse sparad.",
  orgDetailUnableToSavePaymentEvent: "Det gick inte att spara betalningshändelse.",
  orgDetailDeletePaymentEventTitle: "Ta bort den här betalningshändelsen?",
  orgDetailPaymentEventDeleted: "Betalningshändelse borttagen.",
  orgDetailUnableToDeletePaymentEvent: "Det gick inte att ta bort betalningshändelse.",
  orgDetailInviteRoleTitle: "Bjud in organisation {role}?",
  orgDetailInviteRoleWarning:
    "Du håller på att ge {role}-åtkomst i den här organisationen till {email}. {description} Fortsätt?",
  orgDetailThisEmail: "det här e-postmeddelandet",
  orgDetailSendInvite: "Skicka inbjudan",
  orgDetailInvitationSent: "Inbjudan skickad.",
  orgDetailUnableToSendInvitation: "Det gick inte att skicka inbjudan.",
  orgDetailInvitationResent: "Inbjudan skickades igen.",
  orgDetailUnableToResendInvitation: "Det gick inte att skicka om inbjudan.",
  orgDetailInvitationCancelled: "Inbjudan avbruten.",
  orgDetailUnableToCancelInvitation: "Det gick inte att avbryta inbjudan.",
  orgDetailCannotChangeOwnRole: "Du kan inte ändra din egen roll.",
  orgDetailMemberRoleUpdated: "Medlemsroll uppdaterad.",
  orgDetailUnableToUpdateMemberRole: "Det gick inte att uppdatera medlemsroll.",
  orgDetailCannotRemoveSelf: "Du kan inte ta bort dig själv från den här organisationen.",
  orgDetailRemoveMemberTitle: "Ta bort den här medlemmen?",
  orgDetailRemoveMemberWarning:
    "Ta bort den här medlemmen från organisationen? Deras användarkonto förblir aktivt och kan fortfarande tillhöra andra organisationer.",
  orgDetailMemberRemoved: "Medlem borttagen.",
  orgDetailUnableToRemoveMember: "Det gick inte att ta bort medlemmen.",
  orgDetailCannotDeleteOwnAccount: "Du kan inte ta bort ditt eget konto.",
  orgDetailDeleteUserTitle: "Ta bort det här användarkontot?",
  orgDetailDeleteUserWarning:
    "Ta bort den här användaren permanent från identitetssystemet? Detta tar bort all organisationsåtkomst och kan inte ångras. Matchad lokal instrumentpanelsdata behålls.",
  orgDetailDeleteUserConfirmLabel: "Ta bort användare",
  orgDetailUserDeleted: "Användare borttagen.",
  orgDetailUnableToDeleteUser: "Det gick inte att ta bort användare.",
  orgDetailMembersTitle: "Medlemmar",
  orgDetailMembersDescription:
    "Tilldela Medlem, Chef, Utvecklare, Support eller Analytiker för att styra vilka sidor en member kan använda.",
  orgDetailMembersAdminNote:
    "Administratörer kan också tilldela eller ta bort Ägare och permanent ta bort användare.",
  orgDetailOwnerAccessLockedNote: "Ägaråtkomst kan inte ändras här.",
  orgDetailOwnerAccessLocked: "Ägaråtkomst kan inte ändras här",
  orgDetailMembersCount: "{count} medlemmar",
  orgDetailNoMembersFound: "Inga medlemmar hittades i den här organisationen.",
  orgDetailTableMember: "Medlem",
  orgDetailTableEmail: "E-post",
  orgDetailTableRole: "Roll",
  orgDetailTableAccess: "Åtkomst",
  orgDetailTableActions: "Åtgärder",
  orgDetailNoEmailAvailable: "Ingen e-post tillgänglig",
  orgDetailSelfLockNotice:
    "Du kan inte ändra din egen roll, ta bort dig själv eller ta bort ditt eget konto",
  orgDetailRemoveTooltip: "Ta bort från den här organisationen",
  orgDetailDeleteUser: "Ta bort användare",
  orgDetailDeleteUserTooltip: "Ta bort det här användarkontot",
  orgDetailInviteTeamMember: "Bjud in teammedlem",
  orgDetailInviteDescription:
    "Inbjudningar med en annan roll än Medlem kräver bekräftelse innan inbjudan skickas.",
  orgDetailEmailLabel: "E-post",
  orgDetailFirstNameLabel: "Förnamn",
  orgDetailFirstNamePlaceholder: "Förnamn",
  orgDetailLastNameLabel: "Efternamn",
  orgDetailLastNamePlaceholder: "Efternamn",
  orgDetailRoleLabel: "Roll",
  orgDetailSending: "Skickar...",
  orgDetailSendInvitation: "Skicka inbjudan",
  orgDetailInvitationsTitle: "Inbjudningar",
  orgDetailNoInvitationsFound: "Inga inbjudningar hittades.",
  orgDetailExpired: "Utgången",
  orgDetailExpiresInHourSingular: "Går ut om {hours} timme",
  orgDetailExpiresInHoursPlural: "Går ut om {hours} timmar",
  orgDetailBusinessTitle: "Affärsmässigt",
  orgDetailBusinessDescription:
    "Spåra månadsvis återkommande intäkter genom daterade ökningar, minskningar och avhopp.",
  orgDetailCurrentMonthlyPayment: "Aktuell månadsbetalning",
  orgDetailEditPaymentEvent: "Redigera betalningshändelse",
  orgDetailAddPaymentEvent: "Lägg till betalningshändelse",
  orgDetailAmountDeltaLabel: "Beloppsförändring (kr)",
  orgDetailAmountDeltaPlaceholder: "Använd negativa värden för minskningar",
  orgDetailEventDateLabel: "Händelsedatum",
  orgDetailNoteLabel: "Anteckning",
  orgDetailNotePlaceholder: "Avtalsändring, avhoppsorsak, rabatt osv.",
  orgDetailCancelEdit: "Avbryt redigering",
  orgDetailSaveEvent: "Spara händelse",
  orgDetailAddEvent: "Lägg till händelse",
  orgDetailPaymentEventsTitle: "Betalningshändelser",
  orgDetailNoPaymentEvents: "Inga betalningshändelser registrerade.",
  orgDetailEventTypeChurn: "Avhopp",
  orgDetailEventTypeDecrease: "Minskning",
  orgDetailEventTypeIncrease: "Ökning",
  orgDetailPaymentAfterEvent: "Betalning efter händelse: {amount}",
  orgDetailSettingsTitle: "Organisationsinställningar",
  orgDetailSettingsDescription:
    "Realm-administratörer kan uppdatera organisationsspecifika inställningar här. Dessa värden lagras på organisationen istället för på enskilda användare.",
  orgDetailDangerZoneTitle: "Farlig zon",
  orgDetailDangerZoneDescription:
    "Att ta bort organisationen tar bort den från Keycloak och permanent tar bort alla kopplade chatbotar.",
  orgDetailDeleteOrganization: "Ta bort organisation",
  orgDetailDeletingOrganization: "Tar bort organisation...",
  orgDetailDeleteOrganizationSummary:
    '"{name}" har {count} kopplad(e) chatbot(ar). Denna åtgärd kan inte ångras.',
  orgDetailDeleteOrganizationTitle: 'Ta bort organisation "{name}"?',
  orgDetailDeleteOrganizationWarning:
    'Organisation "{name}" och dess {count} kopplade chatbot(ar) ({chatbots}) kommer att permanent tas bort. Medlemskonton tas inte bort.',
  orgDetailDeleteOrganizationNoChatbots: "inga",
};
